export default "<template>\n\n  <KButton\n    text=\"Basic link\"\n    :primary=\"true\"\n    appearance=\"basic-link\"\n  />\n\n</template>\n";